<template>
  <div>
    <el-collapse v-model="active_name" accordion>
      <el-collapse-item :title="question_group.label" :name="group_index" v-for="(question_group,group_index) in answer_table" :key="group_index">
        <template v-if="question_group.group_type==='choice'">
        <ChoiceScoreGroup :question_group="question_group"></ChoiceScoreGroup>
      </template>
      <template v-else>
        <SubjectiveGroup :question_group="question_group"></SubjectiveGroup>
      </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  import ChoiceScoreGroup from "./ChoiceScoreGroup"
  import SubjectiveGroup from "./SubjectiveGroup"

  export default {
    name: "Paper",
    components: {ChoiceScoreGroup, SubjectiveGroup},
    props: ['answer_table'],
    data(){
     return{
       active_name: 0
     }
    }
  }
</script>
